export default __webpack_public_path__ + "images/json-h1ygs.png";